import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import ant from './ant-design/index';
import Login from './views/login.vue';
Vue.use(ant);
Vue.use(VueAxios, axios);

new Vue({
	render: h => h(Login)
}).$mount('#app');